import { all, fork } from 'redux-saga/effects'

import getDetailsSaga from './sagas/getDetails'
import getListSaga from './sagas/getList'
import selectStoreSaga from './sagas/selectStore'
import getAllStoresSaga from './sagas/getAllStores'
import loadMoreSaga from './sagas/loadMoreResult'

function* StoresService() {
  yield all([
    fork(getDetailsSaga),
    fork(getListSaga),
    fork(loadMoreSaga),
    fork(selectStoreSaga),
    fork(getAllStoresSaga),
  ])
}

export default StoresService
